module["exports"] = ["9##-###-###", "9##.###.###", "9## ### ###", "9########"];